const filterAnnualCount = data => {
  // Agrupar os dados por mês
  const monthCounts = {}

  data.forEach(item => {
    if (item.date) {
      const date = new Date(item.date)
      const month = date.getMonth() // Extrai o número do mês (0-11)

      if (monthCounts[month]) {
        monthCounts[month] += 1
      } else {
        monthCounts[month] = 1
      }
    }
  })

  // Ordenar os meses
  const months = [
    'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro',
  ]

  // Organizar os dados de acordo com a ordem dos meses
  const labels = months
  const values = months.map((month, index) => monthCounts[index] || 0) // Usar 0 caso não haja registros para o mês

  return {
    labels,
    datasets: [
      {
        label: 'Contagem anual',
        data: values,
        backgroundColor: Array(values.length).fill('#005C96'),
      },
    ],
  }
}

export default filterAnnualCount
